import strings from '@/strings'
import AttentionBox from './../AttentionBox'

const mixin = {
  data: () => ({
    icons: strings.iconModals
  }),
  props: {
    refName: String,
    title: {
      default: 'Aviso',
      type: String
    },
    firstButtonText: {
      type: String
    },
    secondButtonText: {
      type: String
    },
    iconType: {
      default: 'attention',
      type: String
    },
    iconEnabled: {
      default: true,
      type: Boolean
    },
    closeButtonEnabled: {
      default: false,
      type: Boolean
    },
    firstButtonStyle: {
      default: 'btn-nonenary',
      type: String
    },
    secondButtonStyle: {
      default: 'btn-primary',
      type: String
    },
    firstButtonDisabled: {
      default: false,
      type: Boolean
    },
    secondButtonDisabled: {
      default: false,
      type: Boolean
    },
    firstButtonSubText: {
      type: String
    },
    secondButtonSubText: {
      type: String
    },
    buttonsEnabled: {
      default: true,
      type: Boolean
    },
    size: {
      default: 'medium',
      type: String
    },
    warningText: {
      type: String
    },
    warningEnabled: {
      type: Boolean,
      default: false
    },
    warningAction: {
      type: String
    },
    hideTitle: {
      type: Boolean,
      default: false
    },
    hideFirstButton: {
      type: Boolean,
      default: false
    },
    hideSecondButton: {
      type: Boolean,
      default: false
    },
    dismissDisabled: {
      type: Boolean,
      default: false
    },
    hideDismissLink: {
      type: Boolean,
      default: true
    },
    dismissText: {
      type: String
    },
    headerClickable: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'attention-box': AttentionBox
  },
  methods: {
    close () {
      this.$parent.$emit('close')
      this.$refs[this.refName].close()
    },
    open () {
      this.$parent.$emit('open')
      this.$refs[this.refName].open()
    },
    headerAction () {
      this.$parent.$emit('header-action')
    },
    firstButtonAction () {
      this.$parent.$emit('first-cta')
    },
    secondButtonAction () {
      this.$parent.$emit('second-cta')
    },
    warningEvent () {
      this.$parent.$emit('warning-event')
    },
    dismissAction () {
      this.$parent.$emit('dismiss-cta')
    }
  }
}

export default mixin
